/*
 * Copyright (c) 2019 Hildebrand Technology
 */
import { NgModule } from '@angular/core';
import { ExtraOptions, Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/auth-guard.service';
import { OIDCAuthGuard } from './services/oidc-auth-guard.service';
import { LoginComponent } from './public/login/login.component';
import { FaqsLandingComponent } from './public/faqs-landing/faqs-landing.component';
import { FaqsTopicComponent } from './public/faq-topic/faqs-topic.component';
import { FaqDetailedComponent } from './public/faq-detailed/faq-detailed.component';
import { UserStoryDetailedComponent } from './public/user-story-detailed/user-story-detailed.component';
import { GeneratePasswordTokenComponent } from './public/generate-password-token/generate-password-token.component';
import { ResetPasswordComponent } from './public/reset-password/reset-password.component';
import { LandingComponent } from './public/landing/landing.component';
import { BlogComponent } from './public/blog/blog.component';
import { ResourcesListComponent } from './public/resources-list/resources-list.component';
import { ArticleComponent } from './public/article/article.component';
import { GlossaryComponent } from './public/glossary/glossary.component';
import { AboutUsComponent } from './public/about-us/about-us.component';
import { AboutCommunityComponent } from './public/about-community/about-community.component';
import { SearchResultsComponent } from './public/search-results/search-results.component';
import { CommunityHomeComponent } from './public/community-home/community-home.component';
import { TopGlossaryTermsComponent } from './public/top-glossary-terms/top-glossary-terms.component';
import { TagPageComponent } from './public/tag-page/tag-page.component';
import { NotFoundPageComponent } from './public/not-found-page/not-found-page.component';
import { RegisterComponent } from './public/register/register.component';
import { VerifyEmailComponent } from './public/verify-email/verify-email.component';
import { DelightEventParticipationComponent } from './public/delight-event-participation/delight-event-participation.component';
import { BrightComponent } from './public/bright/bright.component';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { TutorialComponent } from './public/tutorial/tutorial.component';
import { InfographicComponent } from './public/infographic/infographic.component';
import { UnsubscribePageComponent } from './public/unsubscribe-page/unsubscribe-page.component';
import { CaseStudyComponent } from './public/case-study/case-study.component';
import { CaseStudiesLandingComponent } from './public/case-studies-landing/case-studies-landing.component';
import { ProfessionalsRegisterComponent } from './public/professionals-register/professionals-register.component';
import { PrivacyPolicyComponent } from './public/privacy-policy/privacy-policy.component';
import { ContactUsComponent } from './public/contact-us/contact-us.component';
import { ProfessionalRegisterFormComponent } from './public/professional-register-form/professional-register-form.component';
import { SuccessfulRegisterComponent } from './public/successful-register/successful-register.component';
import { InstallerPageComponent } from './public/installer-page/installer-page.component';
import { RegisterHomeComponent } from './public/register/register-home/register-home.component';
import { FindAProfessionalComponent } from './public/find-a-professional/find-a-professional.component';

export const routes: Routes = [
  {
    path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: 'professional',
    canActivate: [OIDCAuthGuard],
    loadChildren: () => import('./pages-professional/pages-professional.module').then((m) => m.PagesProfessionalModule),
  },
  { path: 'home', component: LandingComponent },
  // { path: 'home/:userStory', component: UserStoryDetailedComponent },
  { path: 'login', component: LoginComponent },
  { path: 'home/blogs/:blog', component: BlogComponent },
  { path: 'home/user-stories/:userStory', component: UserStoryDetailedComponent },
  { path: 'home/resources-lists/:resourceList', component: ResourcesListComponent },
  { path: 'home/tutorials/:tutorial', component: TutorialComponent },
  { path: 'support', component: FaqsLandingComponent },
  { path: 'support/:topic', component: FaqsTopicComponent },
  { path: 'support/:topic/:faq', component: FaqDetailedComponent },
  { path: 'unsub/:id', component: UnsubscribePageComponent },
  { path: 'generate-password-token', component: GeneratePasswordTokenComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  // { path: 'tutorial', component: TutorialComponent },
  { path: 'home/articles/:article', component: ArticleComponent },
  { path: 'glossary', component: GlossaryComponent },
  { path: 'glossary/:topGlossaryTerms', component: TopGlossaryTermsComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'about-community/:community', component: AboutCommunityComponent },
  { path: 'community/:community', component: CommunityHomeComponent },
  { path: 'search', component: SearchResultsComponent },
  { path: 'tag/:tag', component: TagPageComponent },
  { path: 'home/infographics/:infographic', component: InfographicComponent },
  { path: 'case-studies', component: CaseStudiesLandingComponent },
  { path: 'case-studies/:caseStudy', loadChildren: () => import('./public/case-study/case-study.module').then((m) => m.CaseStudyModule) },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'delight-event-participation', component: DelightEventParticipationComponent },
  { path: 'cookies', component: CookiePolicyComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: 'bright', component: BrightComponent },
  // { path: 'installers', component: InstallerPageComponent },
  // { path: 'set-password', component: SetPasswordComponent },
  { path: 'register/personal', component: RegisterComponent },
  { path: 'register', component: RegisterHomeComponent },
  { path: 'professionals-register', component: ProfessionalsRegisterComponent },
  { path: 'professionals-register/:role', component: ProfessionalRegisterFormComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'successful-register', component: SuccessfulRegisterComponent },
  { path: 'find-a-professional', component: FindAProfessionalComponent },
  { path: 'find-a-professional/:results', component: FindAProfessionalComponent },
  // { path: 'verify', component: VerificationComponent },
  { path: 'verify-email', component: VerifyEmailComponent },
  // { path: '**', redirectTo: 'home' },
  { path: 'signedout', redirectTo: 'login' },
  { path: 'auth/callback', redirectTo: 'login' }, // professional/landing
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', pathMatch: 'full', component: NotFoundPageComponent },
];

const config: ExtraOptions = {
  useHash: false,
  scrollPositionRestoration: 'enabled',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
